import semaglutideBottle from "src/assets/semaglutideBottle.png";
import tirzepatideBottle from "src/assets/tirzepatideBottle.png";
import oralBottle from "src/assets/oral-bottle.png";
import rapidRegrowthSerum from "src/assets/fhl-serum.png";
import mhlHairGrowthPack from "src/assets/mhl-oral.png";
import mhlRapidRegrowthSerum from "src/assets/mhl-topical.png";
import birthControlPack from "src/assets/birth-control-pack.png";
import emergencyContraception from "src/assets/emergency-contraception-2.png";
import bossMaxPill from "src/assets/ed/boss-max.png";
import sildenafilPill from "src/assets/ed/sildenafil.png";
import tadalafilPill from "src/assets/ed/tadalafil.png";
import antiAging from "src/assets/anti-aging/RxSkin-payment.png";
import glp1Insurance from "src/assets/glp1-ins.png";
import oralGlp1 from "src/assets/oral-glp1.png";
import { Box, SxProps, Theme } from "@mui/material";

interface Props {
  name: string;
  slug: string;
  /** Optional square size for the container */
  size?: number | string;
  /** Optional container width/height (overrides size) */
  width?: number | string;
  height?: number | string;
  /** Contain vs cover (default: contain) */
  fit?: "contain" | "cover";
  /** Pass-through styles for the container */
  sx?: SxProps<Theme>;
}

export const MedicationIcon = ({
  name,
  slug,
  size,
  width,
  height = 100,
  fit = "contain",
  sx,
}: Props) => {
  let src: string | null = null;

  if (["st", "st-ot"].includes(slug)) {
    src = semaglutideBottle;
  } else if (["tr", "tr-ot"].includes(slug)) {
    src = tirzepatideBottle;
  } else if (name.includes("Hair Growth Pack") && slug === "mhl-ot") {
    src = mhlHairGrowthPack;
  } else if (name === "Rapid Regrowth Serum" && slug === "mhl-ot") {
    src = mhlRapidRegrowthSerum;
  } else if (["aa-ot", "ac-ot", "ro-ot"].includes(slug ?? "")) {
    src = antiAging;
  } else if (
    [
      "Complete Hair Growth Pack",
      "Hair Growth Pack",
      "Metformin",
      "Ondansetron",
      "Fresh Start Pack",
      "Biotin",
    ].includes(name) ||
    ["amh-ot", "bb-ot", "sl-ot", "os-ot", "db-ot", "cv-ot"].includes(slug || "")
  ) {
    src = oralBottle;
  } else if (name.includes("Rapid Regrowth Serum")) {
    src = rapidRegrowthSerum;
  } else if (name.includes("Birth Control")) {
    src = birthControlPack;
  } else if (name.includes("Emergency Contraception")) {
    src = emergencyContraception;
  } else if (
    ["Sildenafil + Tadalafil", "Boss Max", "Sildenafil/Tadalafil"].includes(
      name,
    )
  ) {
    src = bossMaxPill;
  } else if (["Sildenafil (generic Viagra)", "Sildenafil"].includes(name)) {
    src = sildenafilPill;
  } else if (["Tadalafil  (generic Cialis)", "Tadalafil"].includes(name)) {
    src = tadalafilPill;
  } else if (name === "Insurance GLP-1") {
    src = glp1Insurance;
  } else if (["wp-ot"].includes(slug)) {
    src = oralGlp1;
  }

  if (!src) return null;

  return (
    <Box
      sx={{
        width: width ?? size ?? "auto",
        height: height ?? size ?? "auto",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        ...sx,
      }}
    >
      <Box
        component="img"
        src={src}
        alt={name}
        sx={{
          maxWidth: "100%",
          maxHeight: "100%",
          width: "100%",
          height: "100%",
          objectFit: fit,
          display: "block",
        }}
      />
    </Box>
  );
};
